// extracted by mini-css-extract-plugin
export default {"teethMovement":"teethMovement___jdEOu","teethMovement_container":"teethMovement_container___Xg_nB"};